import * as React from 'react';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';

export enum ButtonTheme {
     Blue = 'blue',
     LightBlueWithBorder = 'light-blue-with-border',
     LightRedWithBorder = 'light-red-with-border',
}

export enum ButtonSize {
     SuperSmall = 'smaller',
     Small = 'small',
     Medium = 'medium',
     Big = 'big',
}

export enum ButtonIcons {
     Refresh = 'refresh',
}

export enum ButtonFontWeight {
     Normal = 'normal',
     Bold = 'bold',
}

interface ButtonProps {
     theme: ButtonTheme;
     size?: ButtonSize;
     label: string;
     title?: string;
     onClick: () => void;
     fontWeight?: ButtonFontWeight;
     width?: number;
     height?: number;
     icon?: ButtonIcons | ReactChildrenGeneralType;
     disabled?: boolean;
     className?: string;
}


export function Button({
     label,
     title,
     theme,
     size = ButtonSize.Medium,
     width,
     height,
     icon,
     disabled,
     className,
     fontWeight = ButtonFontWeight.Normal,
     onClick
}: ButtonProps) {
     const style = {
          fontWeight: fontWeight
     } as any;
     if (width) {
          style.minWidth = `${width}px`;
          style.maxWidth = `${width}px`;
          style.width = `${width}px`;
     }
     if (height) {
          style.minHeight = `${height}px`;
          style.maxHeight = `${height}px`;
          style.height = `${height}px`;
     }
     return <div className={`action-btn ${size} ${theme} ${className} ${disabled ? 'disabled' : ''}`}
          style={style}
          title={title}
          onClick={onClick}>
          {icon ? (ICONS[icon as ButtonIcons] ? ICONS[icon as ButtonIcons] : icon) : <></>}
          {label}
     </div>;
}

const ICONS = {
     [ButtonIcons.Refresh]: <i className="icon icon-alan-refresh" />
}